import { Component, EventEmitter, Output } from '@angular/core';

/**
 * Generated class for the CoNumberpadComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-numberpad',
  templateUrl: 'co-numberpad.html'
})
export class CoNumberpadComponent {
  numberRows: any = [['1','2','3'],['4','5','6'],['7','8','9'],['*','0','<']];
  text: string;
  @Output() numberKeyPressed: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.text = 'Hello World';
  }

  onClickNumber(event){
    this.numberKeyPressed.emit(event)
  }
}



// WEBPACK FOOTER //
// ./src/components/co-numberpad/co-numberpad.ts